import { Reducer } from 'redux'
import { AllocateFundState, AllocateFundActionTypes } from './types'
import { AuthActionTypes } from '../auth'

export const initialState: AllocateFundState = {
  isSubmitting: false,
  success: false,
  failure: false,
  error: undefined,
  isFetching: false,
  isFetchingReportTransactions: false,
  transactions: [],
  reportTransactions: [],
  reportTransactionsError: undefined,
  isExporting: false,
  fundTransactionsExportError: undefined,
  isVerifying: false
}

const reducer: Reducer<AllocateFundState> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.DESTROY_STATES:
      return initialState
    case AllocateFundActionTypes.ALLOCATE_FUNDS_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: undefined,
        failure: false
      }
    case AllocateFundActionTypes.ALLOCATE_FUNDS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      }
    case AllocateFundActionTypes.ALLOCATE_FUNDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        failure: true
      }
    case AllocateFundActionTypes.FUNDS_TRANSACTIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      }
      case AllocateFundActionTypes.FUNDS_TRANSACTIONS_SUCCESS:
        return {
          ...state,
          isFetching: false,
          transactions: action.payload
      }
      case AllocateFundActionTypes.FUNDS_TRANSACTIONS_FAILURE:
        return {
          ...state,
          isFetching: false
        }
      case AllocateFundActionTypes.REPORT_FUNDS_TRANSACTIONS_REQUEST:
        return {
          ...state,
          isFetchingReportTransactions: true,
          reportTransactions: [],
          reportTransactionsError: undefined
        }
      case AllocateFundActionTypes.REPORT_FUNDS_TRANSACTIONS_SUCCESS:
        return {
          ...state,
          isFetchingReportTransactions: false,
          reportTransactions: action.payload
        }
      case AllocateFundActionTypes.REPORT_FUNDS_TRANSACTIONS_FAILURE:
        return {
          ...state,
          isFetchingReportTransactions: false,
          reportTransactions: [],
          reportTransactionsError: action.payload
        }
      case AllocateFundActionTypes.EXPORT_TRANSACTIONS_REQUEST:
        return {
        ...state,
        isExporting: true,
          fundTransactionsExportError: undefined
        }
      case AllocateFundActionTypes.EXPORT_TRANSACTIONS_SUCCESS:
        return {
        ...state,
        isExporting: false,
          fundTransactionsExportError: undefined
        }
      case AllocateFundActionTypes.EXPORT_TRANSACTIONS_FAILURE:
        return {
        ...state,
        isExporting: false,
          fundTransactionsExportError: action.payload
        }
      case AllocateFundActionTypes.CLEAR_STATES:
        return {
          ...state,
          isFetching: false,
          isFetchingReportTransactions: false,
          success: false,
          failure: false,
          error: undefined,
          reportTransactionsError: undefined,
          isExporting: false,
          fundTransactionsExportError: undefined,
          isVerifying: false
      }
      case AllocateFundActionTypes.VERIFY_FUNDS_ALLOCATION_REQUEST:
        return {
          ...state,
          isVerifying: true,
          error: undefined
      }
      case AllocateFundActionTypes.VERIFY_FUNDS_ALLOCATION_SUCCESS:
        return {
          ...state,
          isVerifying: false,
          success: true
        }
      case AllocateFundActionTypes.VERIFY_FUNDS_ALLOCATION_FAILURE:
        return {
          ...state,
          isVerifying: false,
          failure: true,
          error: action.payload
        }
    default:
      return state
  }
}

export { reducer as allocateFundsReducer }
